import { ArrowLeft } from "components/icons/generated";
import Button from "ds/components/Button";
import Icon from "ds/components/Icon";
import useTypedContext from "hooks/useTypedContext";

import { ModuleFormContext } from "../context";

type NewModuleFooterBackButtonProps = {
  callback?: () => void;
  disabled?: boolean;
  loading?: boolean;
};

const NewModuleFooterBackButton = ({
  callback,
  loading,
  disabled,
}: NewModuleFooterBackButtonProps) => {
  const { goToPreviousStep } = useTypedContext(ModuleFormContext);

  const goBack = () => {
    callback?.();
    goToPreviousStep();
  };

  return (
    <Button
      variant="secondary"
      onPress={goBack}
      loading={loading}
      disabled={disabled}
      startIcon={({ className }) => <Icon src={ArrowLeft} className={className} />}
    >
      Back
    </Button>
  );
};

export default NewModuleFooterBackButton;
